const BASE_PATH = "auth/group";

export const GroupsEndpoint = {
    ALL: BASE_PATH,
    CREATE: BASE_PATH,
    SINGLE: `${BASE_PATH}/{{id}}`,
    ADD_PATIENT: `${BASE_PATH}/{{id}}/assign`,
    REMOVE_PATIENT: `${BASE_PATH}/{{id}}/deny`,
};
